import { useState, useEffect } from 'react'
import { DropdownItemWrap } from './style'

const DropdownItem = ({ children, onClick, ...props }) => {
  const [isTouched, setIsTouched] = useState(false)

  const handleTouchStart = () => setIsTouched(true)

  const handleOutsideClick = (event) => {
    if (!event.target.closest('.dropdown-item')) {
      setIsTouched(false)
    }
  }

  useEffect(() => {
    document.addEventListener('touchstart', handleOutsideClick)
    return () => {
      document.removeEventListener('touchstart', handleOutsideClick)
    }
  }, [])

  return (
    <DropdownItemWrap
      className={`dropdown-item ${isTouched ? 'touch' : ''}`}
      onTouchStart={handleTouchStart}
      onClick={onClick}
      {...props}
    >
      {children}
    </DropdownItemWrap>
  )
}

export default DropdownItem
